<template>
    <div class='bottom-footer-container'>
        <div class="details">
            <div class="detail-1">© Majestic Wine Warehouse Ltd {{year}}</div>
            <!-- <div class="detail-2">By shopping at Majestic you confirm you are over 18.</div>
            <div class="detail-2">You may be asked to provide ID on receipt of delivery.</div> -->
        </div>
        <div class="bottom-links">
          <!-- <a href='https://www.drinkaware.co.uk/'><img class='drink-aware-logo' src="/images/footer/drink-aware.png"/></a> -->
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            year: new Date().getFullYear()
        }
    },
    methods: {
        onClickLink(page) {
            this.$router.push(`/${page}`);
        }
    }
}
</script>

<style lang="scss" scoped>
.bottom-footer-container{
    display: flex;
    justify-content: space-between;
    color: var(--black);
    align-items: center;

    @media(max-width: 1500px){
        
    }

    @media(max-width: 768px){
        justify-content: center;
        gap: 20px;  
        flex-direction: column;
    }
}

.details{
       align-items: center;

    color: var(--maj-slate);
    flex-basis: 33%;

    @media(max-width: 1600px){
        flex-basis: 50%;
    }

    @media(max-width: 768px){
        flex-basis: 100%;
    }
}

.detail-1{
    font-size: 1rem;
    margin-bottom: 7px;
}
.detail-2{
    font-size: 0.725rem;
    font-weight: 300;
}
.footer-link{
    font-weight: 600;
}

.drink-aware-logo{
    width: 200px;
    margin-top: -8px;
    cursor: pointer;
}
</style>